import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// En staging (npm run build:staging) estos valores vienen de .env.staging;
// en producción (npm run build), de los valores por defecto de abajo.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDbt3yvUQcwNQ3c1_yw2sa1DblqWUYzcCI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "admin.goam.com.mx",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "goam-admin",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "goam-admin.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1096598980439",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1096598980439:web:b9f097373712e9dfcb6012",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YGS9SF1KJ5"
};

const app = initializeApp(firebaseConfig);

// Reemplaza enableIndexedDbPersistence (deprecated) con la API moderna
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});

export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
